import {Component} from "react";
import {IActionBase} from "./IActionBase";
import {ActionsManager} from "./actionsManager";
import {store} from "../../redux/storeConfig/store";
import {callPostService} from "../services/api_service";
import {webResponseObject} from "../services/webResponseResponse";
import {utils_ui} from "../utils/utils_ui";
import {dataUtils} from "../js/dataUtils";

export class action_AP_ExecutePageTrigger extends Component implements IActionBase {
    actionCode = "ExecutePageTrigger";
    actionName = "Execute Page Trigger";

    Execute = (prmActionParameters: any, prmActionsManager: ActionsManager, prmElementObj?: any) => {

        // let pageTriggers = JSON.parse(APPLYOO.runtimeUtils.rootScopeObj.selectedPageMetadataObj.PageProperties.TriggersObj);
        const pageStructure: any = store.getState().store_PageStructure.pageStructure
        const pageTriggers = JSON.parse(pageStructure?.PageProperties?.TriggersObj)

        let arrSelectedTrigger = pageTriggers?.filter((prmItem:any) => {
            return prmItem.name == prmActionParameters.SelectedTrigger;
        })
        if (arrSelectedTrigger.length > 0 && !!arrSelectedTrigger[0].actions) {
            prmActionsManager.executeActions(arrSelectedTrigger[0].actions, prmElementObj)
            // APPLYOO.runtimeUtils.scopeObj.executeArrActions(arrSelectedTrigger[0].actions, prmElement);
        }
    }
}